<template>
  <div id="app">
    <p class="title is-1" style="text-align: center; padding: 1rem 0 4rem 0;">Monitoring - {{serverName}}</p>

    <div class="columns">
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title level">
              <span class="level-left">Memory</span><span>{{memUsage}}</span>
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-memory :serverUrl="serverUrl" @valueChanged="(e) => {memUsage = e;}" />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title level">
              <span class="level-left">CPU</span><span>{{cpuUsage}}</span>
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-cpu :serverUrl="serverUrl" @valueChanged="(e) => {cpuUsage = e;}" />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title level">
              <span class="level-left">Temperatur</span><span>{{tempCurrent}}</span>
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-temperatur :serverUrl="serverUrl" @valueChanged="(e) => {tempCurrent = e;}" />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Network
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-network :serverUrl="serverUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <monitor-info :serverUrl="serverUrl" @loaded="(serverName) => {this.serverName = serverName}" />
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Storage
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-hdd :serverUrl="serverUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title level">
              <span class="level-left">Fan</span>
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-fan :serverUrl="serverUrl" />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Services
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-services :serverUrl="serverUrl" />
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Raid
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <monitor-mdadm :serverUrl="serverUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonitorMemory from "./components/MonitorMemory";
import MonitorTemperatur from "./components/MonitorTemperatur";
import MonitorCpu from "./components/MonitorCpu";
import MonitorNetwork from "./components/MonitorNetwork";
import MonitorHdd from "./components/MonitorHdd";
import MonitorServices from "./components/MonitorServices";
import MonitorFan from "./components/MonitorFan";
import MonitorInfo from "./components/MonitorInfo";
import MonitorMdadm from "./components/MonitorMdadm";

export default {
  name: "App",
  props: {
    isApp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      serverName: "",
      serverUrl: "",
      cpuUsage: "",
      memUsage: "",
      tempCurrent: "",
      baseurl: ""
    };
  },
  created() {
    if (this.isApp) {
      this.baseurl = "/app/monitor/";
    }
    this.$http.get(this.baseurl + "static/server").then(response => {
      this.serverUrl = response.data.toString().trim();
    });
  },
  components: {
    "monitor-memory": MonitorMemory,
    "monitor-temperatur": MonitorTemperatur,
    "monitor-cpu": MonitorCpu,
    "monitor-network": MonitorNetwork,
    "monitor-hdd": MonitorHdd,
    "monitor-services": MonitorServices,
    "monitor-fan": MonitorFan,
    "monitor-info": MonitorInfo,
    "monitor-mdadm": MonitorMdadm
  }
};
</script>

<style>
html {
  overflow-y: auto;
}
body {
  padding: 1rem;
}
.card {
  height: 100%;
}
.card-content .content div:not(:last-child) {
  margin-bottom: 1.5rem;
}
.c3-chart-arcs-background {
  fill: #31363b !important;
  stroke: #31363b !important;
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/App.vue